import { NgModule }      from '@angular/core';
import { CommonModule }  from '@angular/common';
import { FormsModule} from '@angular/forms';
import { Routes, RouterModule }  from '@angular/router';


import {HiringRequest} from "./hiringrequest.page";

export const routes: Routes = [
    { path: 'hiringrequest', component: HiringRequest }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        HiringRequest
    ]
})

export class HiringrequestModule { }



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/hiringrequest/hiringrequest.module.ts